/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationSharedPoloListQueryResponse,
  GetApiV1CourseregistrationSharedPoloListQueryParams,
  GetApiV1CourseregistrationSharedPoloList401,
  GetApiV1CourseregistrationSharedPoloList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedPoloList.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationSharedPoloList } from "../../clients/courseRegistrationSharedController/getApiV1CourseregistrationSharedPoloList.ts";

export const getApiV1CourseregistrationSharedPoloListQueryKey = (
  params?: GetApiV1CourseregistrationSharedPoloListQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/shared/polo-list" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationSharedPoloListQueryKey = ReturnType<
  typeof getApiV1CourseregistrationSharedPoloListQueryKey
>;

export function getApiV1CourseregistrationSharedPoloListQueryOptions(
  params?: GetApiV1CourseregistrationSharedPoloListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1CourseregistrationSharedPoloListQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationSharedPoloListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedPoloList401
      | GetApiV1CourseregistrationSharedPoloList500
    >,
    GetApiV1CourseregistrationSharedPoloListQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationSharedPoloList(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista de polos disponíveis para o usuário autenticado. Se o parâmetro 'main' for verdadeiro, adiciona a opção '- Pecege Online -' no início da lista. Usuários com papel Polo recebem apenas os polos vinculados a eles; demais usuários recebem todos os polos ativos filtrados pela empresa. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de polos para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/polo-list}
 */
export function useGetApiV1CourseregistrationSharedPoloList<
  TData = GetApiV1CourseregistrationSharedPoloListQueryResponse,
  TQueryData = GetApiV1CourseregistrationSharedPoloListQueryResponse,
  TQueryKey extends QueryKey = GetApiV1CourseregistrationSharedPoloListQueryKey,
>(
  params?: GetApiV1CourseregistrationSharedPoloListQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationSharedPoloListQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationSharedPoloList401
          | GetApiV1CourseregistrationSharedPoloList500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationSharedPoloListQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationSharedPoloListQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedPoloList401
      | GetApiV1CourseregistrationSharedPoloList500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
